import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('AccountAssignmentGroup?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('AccountAssignmentGroup/show/'+id);
    },    
    create(params) {
        return Service().post('AccountAssignmentGroup/create', params);
    },
    update(id, params) {
        return Service().post('AccountAssignmentGroup/update/'+id, params);
    },
    delete(id) {
        return Service().post('AccountAssignmentGroup/delete/'+id);
    }
}